export default __webpack_public_path__ + "static/media/time2.20b9ebc0.svg";